module.exports = __webpack_public_path__ + "img/banner1.23286c89.png";